import template	from "./view-whatsnew.html";
import css		from "./view-whatsnew.css";

import Page			from "../view-page.js";
import Richbox	from "richbox";

export default class WhatsNewView extends Page {
  static get template() {
    return template;
  }
  
  static get css() {
    return css;
  }
  
  static {
    customElements.define("fulljs-view-whatsnew", WhatsNewView);
  }

  constructor(...args) {
    super(...args);
  }
}